import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Download from "../../components/Files/downloadDocuments";
import Pagination from "../../components/Pagination";
import SortedHeader from "../../components/Tables/SortedHeader";
import { FileContentService } from "../../services/FileContentSearch";
import FolderSearch from "../../layout/left_menu_icons/folder_search.svg";

export default function FileContentSearchPage() {
  const { t } = useTranslation();
  const [searchObject, setSearchObject] = useState({ order: 1 });
  const [result, setResult] = useState([]);
  const [canExport, setCanExport] = useState(false);
  const format = { excel: 0, pdf: 1 };
  const [listExportDownloadStatus, setListExportDownloadStatus] = useState({
    statusName: "done",
    errorCaught: false
  });

  const [headers, setHeaders] = useState([
    { label: t("Full Name") },
    { label: t("Job Role") },
    { label: t("Manager") },
    { label: t("Mobile number") },
    { label: t("Availability") },
    { label: t("Expected Salary") },
    { label: t("Created Date") },
    { label: t("Technologies") },
    { label: t("Upload Date"), field: "uploadDate", sorted: true },
    { label: t("File") }
  ]);

  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, SetTotalPages] = useState(0);
  const formatAllow = { excel: 0, pdf: 1 };

  useEffect(() => {
    if (searchObject.searchText) searchInFile();
  }, [pageNumber, pageSize, searchObject.order]);

  function onChange({ target }) {
    setSearchObject({ ...searchObject, [target.name]: target.value });
  }

  function searchInFile() {
    FileContentService.search(pageSize, pageNumber, searchObject).then(
      (data) => {
        let sortedData = [...data.page];

        if (searchObject.orderby) {
          sortedData.sort((a, b) => {
            const aValue = a[searchObject.orderby];
            const bValue = b[searchObject.orderby];

            if (moment(aValue).isValid() && moment(bValue).isValid()) {
              return searchObject.order === 1
                ? moment(aValue).diff(moment(bValue))
                : moment(bValue).diff(moment(aValue));
            }

            if (aValue < bValue){
              return searchObject.order === 1 ? -1 : 1;
            } 

            if (aValue > bValue){
              return searchObject.order === 1 ? 1 : -1;
            } 
            return 0;
          });
        }

        setResult(sortedData);
        SetTotalPages(Math.ceil(data.total / pageSize));

        const EXPORT_LIMIT = 1000;
        setCanExport(data.total <= EXPORT_LIMIT);
      }
    );
  }

  function openDetails(result) {
    let url = `/precandidate?precandidateId=${result.precandidateId}`;
    if (result.interviewId) {
      url = `/interview/view/${result.interviewId}`;
    }

    window.open(url).focus();
  }

  function handleExport(format) {
    let fileName = "";
    if (format === formatAllow.excel) {
      fileName = `${t("Documents")}_${new Date().toLocaleDateString()}.xlsx`;
    } else {
      fileName = `${t("Documents")}_${new Date().toLocaleDateString()}.pdf`;
    }
    let _searchObject = { ...searchObject };
    if (_searchObject.businessAreas?.length > 0)
      _searchObject.businessAreas = _searchObject.businessAreas.map(
        (item) => item.id
      );
    FileContentService.exportToexcel(
      pageSize,
      pageNumber,
      fileName,
      format,
      _searchObject
    );
  }

  return (
    <>
      {" "}
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={FolderSearch} alt="ni-icon" />
            <h1 style={{ marginTop: "10px" }}>{t("File Content Search")}</h1>
          </div>
          <div className="subtitle">{t("File / Search")}</div>
        </div>
        <div>
          <textarea className="text-area-styles" rows="4" disabled>
            {t(
              "Search forms (use exactly as in the examples below, changing the expression to the word you want to search for)."
            ) +
              "\n" +
              t("") +
              "\n" +
              t(
                '1 - "expression"|"expression" - will return documents that contain any of the 2 words entered.'
              ) +
              "\n" +
              t(
                "2 - expression-expression - will return documents that have the first expression but not the second."
              ) +
              "\n" +
              t(
                "3 - expression+expression - will return exactly the document that has all those words typed."
              ) +
              "\n" +
              t(
                '4 - "expression+expression" - will return documents with the following words.'
              ) +
              "\n" +
              t(
                "5 - expression+expression|expression - will return documents that contain the first expression + one of the other two expressions."
              ) +
              "\n" +
              t(
                "6 - expre* - will return documents that have words starting with the typed one."
              )}
          </textarea>
        </div>
      </header>
      <div className="row">
        <div className="col-6">
          <span></span>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              style={{height: "40px"}}
              onChange={onChange}
              value={searchObject.searchText || ""}
              name="searchText"
            ></input>
            <button
              className="btn btn-outline-secondary"
              style={{height: "40px"}}
              onClick={searchInFile}
              disabled={!searchObject.searchText}
            >
              {t("search")}
            </button>
            <div style={{marginLeft: "30px"}}>
              <div className="export-button">
                <button
                  type="button"
                  id="exportPreCandidates"
                  className="app-button btn-second btn-md"
                  aria-expanded="false"
                  style={{ marginTop: "1px" }}
                  disabled={!canExport || listExportDownloadStatus.statusName === "downloading"}
                  onClick={() => {
                    handleExport(formatAllow.excel);
                  }}
                >
                  {t("Export")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table-wrap">
        <table className="table-position">
          <thead>
            <SortedHeader
              searchObject={searchObject}
              setSearchObject={setSearchObject}
              headers={headers}
              setHeaders={setHeaders}
            />
          </thead>
          <tbody>
            {result.map((interview, index) => (
              <tr key={index} onClick={() => openDetails(interview)}>
                <td style={{width:"200px"}}>{interview.candidateName}</td>
                <td>{interview.jobRole}</td>
                <td style={{width:"200px"}}>{interview.manager}</td>
                <td>{interview.mobileNumber}</td>
                <td>{t(interview.availability)}</td>
                <td>{interview.expectedSalary}</td>
                <td>{moment(interview.createdDate).format("DD-MM-YYYY")}</td>
                <td style={{width:"450px"}}>
                  {interview.technologies &&
                    interview.technologies.map((skill, index) => (
                      <span key={index} style={{ fontSize: 10 }}>
                        {" "}
                        {skill},
                      </span>
                    ))}
                </td>
                <td>{moment(interview.uploadDate).format("DD-MM-YYYY")}</td>
                <td>
                  {" "}
                  <Download
                    url={`vitae/file/${interview.documentId}`}
                    fileName={interview.fileName}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>{" "}
      <Pagination
        totalPages={totalPages}
        setPageNumber={setPageNumber}
        pageNumber={pageNumber}
        setPageSize={setPageSize}
      />
    </>
  );
}
